import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';
import axFile from 'src/store/configFile';


const initialState = {
    galeryList: null,
    galeryListLoading: false
};

export const galeryAction = createAsyncThunk('galeryAction', async (payload, { dispatch }) => {
    dispatch(setGaleryListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/gallery';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setGaleryListLoading(false))
                return data

            case 'post':
                ({ data } = await axFile.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Галерея успешно отредактирована`
                })
                break;

            case 'put':
                ({ data } = await axFile.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Галерея успешно добавлена`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Галерея успешно удалена`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setGaleryListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const GalerySlice = createSlice({
    name: 'galery',
    initialState,
    reducers: {
        setGaleryListLoading: (state, action) => {
            state.galeryListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(galeryAction.fulfilled, (state, action) => {
            state.galeryList = action.payload
        })
    }
});

export const { setGaleryListLoading } = GalerySlice.actions;

export default GalerySlice.reducer